<!-- Modal Background -->
<div class="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-end sm:items-center" (click)="closeModal()" [ngClass]="{'hidden': !isVisible}">

  <!-- Modal Content -->
  <div class="theme-sheet-gradient w-full sm:max-w-md rounded-t-3xl sm:rounded-3xl px-6 py-16 shadow-lg"
    @bottomSheetAnimation [@bottomSheetAnimation]="animationState"
    (click)="$event.stopPropagation()">

    <button (click)="closeModal()" class="absolute right-6 top-6">
      <svg class="w-[20px] h-[20px] text-theme-muted" fill="none" stroke="currentColor" stroke-width="2"
        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>

    <p class="font-medium text-small pb-6">{{ 'dropdown_menu.change_territory' | translate }}</p>

    <div class="bg-white shadow-[0_4px_16px_rgba(0,0,0,.1)] rounded-2xl">
      @for (availableTerritory of availableTerritories; track availableTerritory; let i = $index) {
        <div class="relative">
          <div class="flex items-center justify-between px-6 py-[1rem] relative pointer-events-auto">
            <div class="flex items-center gap-x-4 cursor-pointer" (click)="changeTerritory(availableTerritory)">
              <img alt="Explore icon" class="h-10"
                [src]="ImageManager.getLogoModalByTerritoryCode(availableTerritory.code)">
                <p class="font-semibold">Xplorer {{ availableTerritory.name }}</p>
              </div>
              @if (availableTerritory.code === getCurrentTerritoryCode()) {
                <div>
                  <svg class="w-6 h-6 custom-base-color" fill="none" stroke="currentColor"
                    xmlns="http://www.w3.org/2000/svg">
                    <use [attr.xlink:href]="ImageManager.checkCircleIcon" />
                  </svg>
                </div>
              }
            </div>
            @if (i < availableTerritories.length - 1) {
              <div class="h-[1px] bg-theme-surface-muted w-full"></div>
            }
          </div>
        }
      </div>

    </div>
  </div>